import useQuery from '@shared/hooks/src/useQuery'
import API from '@shared/services/src/API'
import { QK } from '@shared/utils'

export default function useUser(userId, options = {}) {
  return useQuery({
    queryKey: QK.users.id(userId).details,
    queryFn: () => API.users.id(userId).details(),
    enabled: Boolean(userId),
    ...options,
  })
}
